/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Project, Project$inboundSchema } from "./project.js";

export type UpdateProjectResult = {
  project: Project;
};

/** @internal */
export const UpdateProjectResult$inboundSchema: z.ZodMiniType<
  UpdateProjectResult,
  unknown
> = z.object({
  project: Project$inboundSchema,
});

export function updateProjectResultFromJSON(
  jsonString: string,
): SafeParseResult<UpdateProjectResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateProjectResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateProjectResult' from JSON`,
  );
}
